import React, { Fragment } from "react";
import { Grid, Typography } from "@mui/material";
import { colors } from "../pages/css components/Style";

export default function ComponentHeader({
  icons = [],
  title,
  subtitle,
  buttons = [],
}) {
  return (
    <Grid
      container
      style={{ minHeight: "35px", marginTop: "4px" }}
      alignItems="center"
    >
      <Grid size={4}>
        <Typography
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: colors.sprintexBlue,
          }}
        >
          {title}
        </Typography>

        {!!subtitle && (
          <Typography
            variant="subtitle2"
            gutterBottom
            style={{ color: "#808080b3" }}
          >
            {subtitle}
          </Typography>
        )}
      </Grid>

      <Grid size={8} justifyContent="flex-end" style={{ gap: "5px" }} container>
        {icons.length > 0 &&
          icons.map((icon, index) => (
            <Grid alignSelf={"center"} item key={index}>
              {icon}
            </Grid>
          ))}

        {buttons.length > 0 &&
          buttons.map((button, index) => (
            <Fragment key={index}>{button}</Fragment>
          ))}
      </Grid>
    </Grid>
  );
}
